/**
 *
 * Resubscribe Modal
 *
 * Opened from a channel-management control an account whose subscription has
 * ended can still see — the header's New Channel button, a channel row, the
 * row menu's "edit channel". Those controls are not hidden, because a lapsed
 * account is expected to come back: showing the control and explaining why it
 * is closed is what makes reactivation reachable.
 *
 * Sibling of PlanSelectionModal, which answers the adjacent question (a plan
 * that never covered this) with the same mailto CTA. Both are prompts, not
 * enforcement: the server owns the decision (ChannelPolicy in movebooth-rails).
 */
import React from 'react';
import { ContentWrapper } from './styledComponents';
import Modal from 'components/Modal';
import ResubscribeMessage from 'components/ResubscribeMessage';

const ResubscribeModal = ({ close }) => (
  <Modal shakeOnOpen close={close} title='Resubscribe'>
    <ContentWrapper>
      <ResubscribeMessage />
    </ContentWrapper>
  </Modal>
);

export default ResubscribeModal;
